var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SvgIcon, Link, useTheme } from '@mui/material';
import React, { useMemo } from 'react';
import { resolveStatusColor, resolveStatusIcon } from '../../utils/utils';
var TextStatusIconCellRenderer = function (_a) {
    var boldText = _a.boldText, normalText = _a.normalText, onBoldTextClick = _a.onBoldTextClick, status = _a.status, params = __rest(_a, ["boldText", "normalText", "onBoldTextClick", "status"]);
    // To avoid breaking changes, use value from status. If not provided, use value from params that is passed automatically.
    var palette = useTheme().palette;
    var value = params.value;
    var _b = useMemo(function () {
        var textToDisplay = status !== null && status !== void 0 ? status : value;
        var cmp = onBoldTextClick ? (React.createElement(Link, { onClick: onBoldTextClick }, boldText)) : (React.createElement("strong", null, boldText));
        return [textToDisplay.toLowerCase(), cmp];
    }, [status, value, boldText, onBoldTextClick]), lowerCaseStatus = _b[0], strongOrLink = _b[1];
    return (React.createElement("div", { className: "errorStatus-renderer" },
        React.createElement(SvgIcon, { component: resolveStatusIcon(lowerCaseStatus), htmlColor: resolveStatusColor(lowerCaseStatus, palette), inheritViewBox: true }),
        strongOrLink,
        " ",
        React.createElement("span", null, normalText)));
};
export default TextStatusIconCellRenderer;
